import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { CheckmarkCircle } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { UserActionStatus } from './UserActionStatus';
export const GetRevertedMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const RevertedMessage = (param)=>{
    let { content, messageId } = param;
    const { RevertedMessageTID } = useMemo(()=>GetRevertedMessageTID(messageId), [
        messageId
    ]);
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": RevertedMessageTID.Root(),
        children: /*#__PURE__*/ _jsx(UserActionStatus, {
            Icon: CheckmarkCircle,
            iconSkin: "primary",
            text: content.text,
            testId: RevertedMessageTID.Summary()
        })
    });
};
